import { SITE, NAV_LINKS } from "@/data/site";
import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#1C1917] text-[#F9F6F0] pt-20 pb-10"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-display text-3xl font-light mb-2">
              Harmony Massage
            </h3>
            <p className="text-[#C5A059] text-[11px] tracking-[0.35em] uppercase font-body mb-6">
              Montélimar · Salon de massage
            </p>
            <p className="text-[#F9F6F0]/60 font-light max-w-md leading-relaxed">
              Une parenthèse de bien-être au cœur de Montélimar. Soins
              traditionnels et rituels signature dans un écrin dédié à la
              sérénité.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-body mb-5">
              Navigation
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-[#F9F6F0]/70 hover:text-[#C5A059] transition-colors font-light text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-body mb-5">
              Contact
            </h4>
            <ul className="space-y-3 text-sm font-light text-[#F9F6F0]/70">
              <li>{SITE.address}</li>
              <li>
                <a
                  href={`tel:${SITE.phoneIntl}`}
                  className="hover:text-[#C5A059] transition-colors"
                >
                  {SITE.phone}
                </a>
              </li>
              <li>Lundi — Samedi</li>
              <li>09h00 — 19h00</li>
              <li>Dimanche fermé</li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a
                href="#"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#C5A059] hover:border-[#C5A059] transition-all duration-300"
              >
                <Instagram strokeWidth={1.4} className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#C5A059] hover:border-[#C5A059] transition-all duration-300"
              >
                <Facebook strokeWidth={1.4} className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#F9F6F0]/40 font-light">
          <p>
            © {new Date().getFullYear()} Harmony Massage Montélimar. Tous droits réservés.
          </p>
          <p className="tracking-[0.2em] uppercase">Conçu avec soin</p>
        </div>
      </div>
    </footer>
  );
}
